import * as React from "react";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import SectionView from "../../layout/section/SectionView";
import Row from "../../layout/Row";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Col from "../../layout/Col";
import JobStatusForm from "./JobStatusForm";
import SelectStatusCategoryFormGroup from "./category/SelectStatusCategoryFormGroup";
import JobStatusCategory from "../../../model/job/JobStatusCategory";
import JobStatusExternalCategory from "../../../model/job/JobStatusExternalCategory";
import CheckboxFormGroup from "../../ui/form/CheckboxFormGroup";

type Props = FormBodyProps<JobStatusForm>

export default class JobStatusFormBody extends React.PureComponent<Props, {}> {
	render() {
		return (
			<SectionView>
				<Row>
					<Col xl={5} md={5}>
						<InputFormGroup label="Internal Label"
										placeholder="Enter internal status label"
										field={this.props.form.label}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.label)}/>
					</Col>
					<Col xl={5} md={5}>
						<SelectStatusCategoryFormGroup field={this.props.form.category}
													   placeholder={"Select status category"}
													   onChange={this.props.onFieldChange}
													   label={"Internal category label"}
													   items={JobStatusCategory.getJobStatusCategories()}/>
					</Col>
					<Col xl={5} md={5}>
						<InputFormGroup label="External label"
										placeholder="Enter external status label"
										field={this.props.form.externalLabel}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.externalLabel)}/>
					</Col>
					<Col xl={5} md={5}>
						<SelectStatusCategoryFormGroup field={this.props.form.externalCategory}
													   placeholder={"Select external status category"}
													   onChange={this.props.onFieldChange}
													   label={"External category label"}
													   items={JobStatusExternalCategory.getJobStatusExternalCategories()}/>
					</Col>
				</Row>
				<Row>
					<Col xl={10} md={10}>
						<InputFormGroup label="Description"
										placeholder="Enter description"
										field={this.props.form.description}
										onChange={this.props.onFieldChange}/>
					</Col>
				</Row>
				<Row>
					<Col xl={10} md={10}>
						<CheckboxFormGroup field={this.props.form.showPushNotification}
										   onChange={this.props.onFieldChange}
										   label={"Show notification in app"}/>
					</Col>
				</Row>
			</SectionView>
		);
	}
}
